<template>
  <a-modal
    @ok="visible = false"
    @cancel="visible = false"
    title="活动配置"
    :visible="visible">
    <div style="text-align: center">
      <vue-qr :text="url" :size="200"></vue-qr>
      <p @click="handleCopy"><a>{{ url }}<a-icon type="copy" /></a> </p>
    </div>

  </a-modal>
</template>

<script>
import VueQr from 'vue-qr'
export default {
  name: 'H5urlModal',
  data: () => ({
    visible: false,
    currentRobotId: null,
    loading: false,
    luckyId: null
  }),
  components: {
    VueQr
  },
  computed: {
    mainId() {
      return this.$store.getters.userInfo.id
    },
    url() {
      return `http://cloud_test.nianchu.net/api/6152b743b1e5c?main_id=${this.mainId}&sub_id=${this.currentRobotId}&luckydraw_id=${this.luckyId}`
    }
  },
  methods: {
    handleCopy() {
      this.$copyText(this.url)
      this.$message.success('复制成功')
    },
    show(currentRobotId, luckyId) {
      this.loading = true
      this.currentRobotId = currentRobotId
      this.luckyId = luckyId
      this.visible = true
    }

  }
}
</script>

<style scoped>

</style>
